/**
 * Format a date string as "DD/MM, HH:mm"
 */
export function formatShortDate(dateString: string): string {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${day}/${month}, ${hours}:${minutes}`;
}

/**
 * Get initials from first name and last name
 */
export function getInitials(name: string | null, lastName: string | null): string {
  const firstInitial = name?.charAt(0)?.toUpperCase() ?? '';
  const lastInitial = lastName?.charAt(0)?.toUpperCase() ?? '';
  return `${firstInitial}${lastInitial}` || '?';
}
